module.exports = [
	{
		"id": "11638",
		"title": "2017-05-01: Auth0 11638",
		"old": false,
		"shasum": "3d4b1e5163ab738986424ac18561f3c1025521d9",
		"mirror": "1492637689874",
		"publishedAt": "2017-05-01"
	},
	{
		"id": "11112",
		"title": "2017-03-21: Auth0 11112",
		"old": false,
		"shasum": "6872e9b2b521ee11323a37928e73136ba0ffb679",
		"mirror": "1486178861666",
		"publishedAt": "2017-03-21"
	},
	{
		"id": "10755",
		"title": "2017-02-20: Auth0 10755",
		"old": false,
		"shasum": "d109f633696573b59c2efe14e7011100269f57c6",
		"mirror": "1486178861666",
		"publishedAt": "2017-02-20"
	},
	{
		"id": "10258",
		"title": "2017-01-16: Auth0 10258",
		"old": false,
		"shasum": "5cd65df99b572fedf591b2012de1ff14c808b150",
		"mirror": "1480444054184",
		"publishedAt": "2017-01-16"
	},
	{
		"id": "9632",
		"title": "2016-11-23: Auth0 9632",
		"old": false,
		"shasum": "202b7f16b45e80527c29ed907e80487d3123c32c",
		"mirror": "1477672903221",
		"publishedAt": "2016-11-23"
	},
	{
		"id": "8986",
		"title": "2016-10-13: Auth0 8986",
		"old": false,
		"shasum": "d3460cc161c3f6cc4edd0ea1272b0b182ec97e91",
		"mirror": "1473972402723",
		"publishedAt": "2016-10-13"
	},
	{
		"id": "8293",
		"title": "2016-09-01: Auth0 8293",
		"old": false,
		"mirror": "1472580222495",
		"shasum": "eda299b18d6ac305d2c70106e7b8296e460172cf",
		"publishedAt": "2016-09-01"
	},
	{
		"id": "7941",
		"title": "2016-08-08: Auth0 7941",
		"old": false,
		"mirror": "1470587956368",
		"shasum": "5a0072a42cd95a1287156d88276a478df99b57de",
		"publishedAt": "2016-08-07"
	},
	{
		"id": "7760",
		"title": "2016-07-27: Auth0 7760",
		"old": true,
		"mirror": "1465852204666",
		"shasum": "1da0189c2876be68f4b8c9184a39024db52ae028",
		"publishedAt": "2016-07-27"
	},
	{
		"id": "7247",
		"title": "2016-06-17: Auth0 7247",
		"old": true,
		"mirror": "1465852204666",
		"publishedAt": "2016-06-17",
		"shasum": "7feeac827363b1abf67d1ac3c719261b67115df3"
	},
	{
		"id": "6975",
		"title": "2016-05-28: Auth0 6975",
		"old": true,
		"mirror": "1463609600464",
		"publishedAt": "2016-05-28",
		"shasum": "1996351c2be7c302565eeb32fbb6c999269f63ba"
	},
	{
		"id": "6868",
		"title": "2016-05-20: Auth0 6868",
		"old": true,
		"mirror": "1463609600464",
		"publishedAt": "2016-05-20",
		"shasum": "3d0f7425a34232b1aaaefcb523327fb08e77d81a"
	},
	{
		"id": "6576",
		"title": "2016-05-02: Auth0 6576",
		"old": true,
		"mirror": "1461857277937",
		"publishedAt": "2016-05-02",
		"shasum": "355835502559444dff0a599b2fdbbc046f6138f1"
	},
	{
		"id": "5970",
		"title": "2016-03-23: Auth0 5970",
		"old": true,
		"mirror": "1457812908404",
		"publishedAt": "2016-03-23",
		"shasum": "e405e4e6857ad8f51d7d962061615d1b9eed80c2"
	},
	{
		"id": "5590",
		"title": "2016-02-17: Auth0 5590",
		"old": true,
		"mirror": "1455030487459",
		"publishedAt": "2016-02-17",
		"shasum": "d6d9db40406a9641a5f51c3d6b6e6db8bdd4fb31"
	},
	{
		"id": "5394",
		"title": "2016-01-26: Auth0 5394",
		"old": true,
		"mirror": "",
		"publishedAt": "2016-01-26",
		"shasum": "3f775e64364207f47622210d9a19be52becce8df"
	},
	{
		"id": "4975",
		"title": "2015-12-15: Auth0 4975",
		"old": true,
		"mirror": "",
		"publishedAt": "2015-12-15",
		"shasum": "492c2d7a7570a6409909f3da9b8f4d1dc0a4b7dc"
	},
	{
		"id": "4605",
		"title": "2015-11-21: Auth0 4605",
		"old": true,
		"mirror": "",
		"publishedAt": "2015-11-21",
		"shasum": "ef440975218f41529ae6e05f6d7e388b3dfcce9e"
	},
	{
		"id": "4341",
		"title": "2015-10-23: Auth0 4341",
		"old": true,
		"mirror": "",
		"publishedAt": "2015-10-23",
		"shasum": "330b88448ef432808b3fb775b2377b1493319841"
	},
	{
		"id": "4323",
		"title": "2015-10-22: Auth0 4323",
		"old": true,
		"mirror": "",
		"publishedAt": "2015-10-22",
		"shasum": "5a02e281e0b10f4945896e490bf5d1f1f1e9acf6"
	},
	{
		"id": "4295",
		"title": "2015-10-20: Auth0 4295",
		"old": true,
		"mirror": "",
		"publishedAt": "2015-10-20",
		"shasum": "d75ad7df354786ee29d0268b22b52702a7098415"
	},
	{
		"id": "4013",
		"title": "2015-09-29: Auth0 4013",
		"old": true,
		"mirror": "",
		"publishedAt": "2015-09-29",
		"shasum": "60a46d4dc4feeae25fe8f0dffd2a66a6e856d7db"
	},
	{
		"id": "3615",
		"title": "2015-08-31: Auth0 3615",
		"old": true,
		"mirror": "",
		"publishedAt": "2015-08-31",
		"shasum": "7d656998a176e91e01a0aa5cdc7ff7559aac023f"
	},
	{
		"id": "3601",
		"title": "2015-08-28: Auth0 3601",
		"old": true,
		"mirror": "",
		"publishedAt": "2015-08-28",
		"shasum": "3445495b6f81db46b410cb6b829edccae11b31a2"
	},
	{
		"id": "3454",
		"title": "2015-08-14: Auth0 3454",
		"old": true,
		"mirror": "",
		"publishedAt": "2015-08-14"
	},
	{
		"id": "3258",
		"title": "2015-07-24: Auth0 3258",
		"old": true,
		"mirror": "",
		"publishedAt": "2015-07-24",
		"shasum": "0abef044e2d1e040788adb17d6a279663253646a"
	},
	{
		"id": "3191",
		"title": "2015-07-17: Auth0 3191",
		"old": true,
		"mirror": "",
		"publishedAt": "2015-07-17",
		"shasum": "3a62d526aa1efae7b84462e9b4af1375f3af9aab"
	},
	{
		"id": "3081",
		"title": "2015-07-06: Auth0 3081",
		"old": true,
		"mirror": "",
		"publishedAt": "2015-07-06",
		"shasum": "2b74b7e9324c92ff4254056ad8ca7953e24302f3"
	},
	{
		"id": "2921",
		"title": "2015-06-18: Auth0 2921",
		"old": true,
		"mirror": "",
		"publishedAt": "2015-06-18",
		"shasum": "4ae949d7ac3e866e1175db7d94065d5aeff38f7b"
	},
	{
		"id": "2783",
		"title": "2015-05-29: Auth0 2783",
		"old": true,
		"mirror": "",
		"publishedAt": "2015-05-29"
	},
	{
		"id": "2666",
		"title": "2015-05-22: Auth0 2666",
		"old": true,
		"mirror": "",
		"publishedAt": "2015-05-22"
	},
	{
		"id": "2616",
		"title": "2015-05-15: Auth0 2616",
		"old": true,
		"mirror": "",
		"publishedAt": "2015-05-15"
	},
	{
		"id": "2562",
		"title": "2015-05-08: Auth0 2562",
		"old": true,
		"mirror": "",
		"publishedAt": "2015-05-08"
	},
	{
		"id": "2516",
		"title": "2015-05-01: Auth0 2516",
		"old": true,
		"mirror": "",
		"publishedAt": "2015-05-01"
	},
	{
		"id": "2479",
		"title": "2015-04-25: Auth0 2479",
		"old": true,
		"mirror": "",
		"publishedAt": "2015-04-25"
	},
	{
		"id": "2425",
		"title": "2015-04-18: Auth0 2425",
		"old": true,
		"mirror": "",
		"publishedAt": "2015-04-18"
	},
	{
		"id": "2359",
		"title": "2015-04-10: Auth0 2359",
		"old": true,
		"mirror": "",
		"publishedAt": "2015-04-10"
	},
	{
		"id": "2274",
		"title": "2015-04-03: Auth0 2274",
		"old": true,
		"mirror": "",
		"publishedAt": "2015-04-03"
	},
	{
		"id": "2223",
		"title": "2015-03-27: Auth0 2223",
		"old": true,
		"mirror": "",
		"publishedAt": "2015-03-27"
	},
	{
		"id": "2190",
		"title": "2015-03-20: Auth0 2190",
		"old": true,
		"mirror": "",
		"publishedAt": "2015-03-20"
	},
	{
		"id": "2150",
		"title": "2015-03-13: Auth0 2150",
		"old": true,
		"mirror": "",
		"publishedAt": "2015-03-13"
	},
	{
		"id": "2086",
		"title": "2015-03-06: Auth0 2086",
		"old": true,
		"mirror": "",
		"publishedAt": "2015-03-06"
	},
	{
		"id": "2051",
		"title": "2015-02-28: Auth0 2051",
		"old": true,
		"mirror": "",
		"publishedAt": "2015-02-28"
	},
	{
		"id": "1999",
		"title": "2015-02-20: Auth0 1999",
		"old": true,
		"mirror": "",
		"publishedAt": "2015-02-20"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/pages/changelog/releases.json
// module id = 370
// module chunks = 0